/** @jsx jsx */
import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import React from 'react';
import UniversalNavLink from '../../UniversalNavLink';
import { Divider } from '../Divider';
import { isLinkSelected } from './utils';
import { MoreLinksMenu } from './MoreLinksMenu';
import type { SidebarV3 } from './types';

type InAppLinksProps = {
  isCollapsed: boolean;
  links: Array<SidebarV3.ItemGroup>;
  moreLinks?: SidebarV3.MoreLinks;
  selectedHref: string;
};

const Styles = labelStyles('InAppLinks', {
  linkGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--zds-space-4, 4px)',
    margin: 0,
    padding: 0,
  },
  links: {
    alignContent: 'start',
    display: 'grid',
    listStyle: 'none',
    padding: '0 var(--zds-space-8, 8px)',
  },
  moreLink: {
    marginTop: 'var(--zds-space-4, 4px)',
  },
});

const InAppLinks = ({
  isCollapsed,
  links,
  moreLinks,
  selectedHref,
}: InAppLinksProps) => (
  <React.Fragment>
    <ul css={Styles.links} data-zds>
      {links.map((itemGroup, index) => (
        <React.Fragment key={index}>
          <li data-zds>
            <ul data-zds css={Styles.linkGroup}>
              {itemGroup?.map((item) => {
                const isSelected = isLinkSelected(
                  item.href || '',
                  selectedHref
                );

                const icon = isSelected ? item.iconFilled : item.icon;

                return (
                  <li key={item.text} data-zds>
                    <UniversalNavLink
                      href={item.href!}
                      icon={icon}
                      isCollapsed={isCollapsed}
                      isSelected={isSelected}
                      isSidebar={true}
                      isV3Link={true}
                      text={item.text}
                      tag={item.tag}
                    />
                  </li>
                );
              })}
            </ul>
          </li>
          {index < links.length - 1 && (
            <li aria-hidden="true" data-zds>
              <Divider />
            </li>
          )}
        </React.Fragment>
      ))}
      {moreLinks && (
        <li css={Styles.moreLink} key={moreLinks.text} data-zds>
          <MoreLinksMenu
            isCollapsed={isCollapsed}
            items={moreLinks}
            selectedHref={selectedHref}
          />
        </li>
      )}
    </ul>
  </React.Fragment>
);

export default InAppLinks;
